module.exports = {
          srcSet: __webpack_public_path__ + "2f11493ebf0f24fed7e656eeabb34fe8-1040.png"+" 1040w",
          images:[ {path: __webpack_public_path__ + "2f11493ebf0f24fed7e656eeabb34fe8-1040.png",width: 1040,height: 621}],
          src: __webpack_public_path__ + "2f11493ebf0f24fed7e656eeabb34fe8-1040.png",
          toString:function(){return __webpack_public_path__ + "2f11493ebf0f24fed7e656eeabb34fe8-1040.png"},
          
          width: 1040,
          height: 621
        }